























































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import UserMatrixForm from '@/components/Net20/UserMatrixForm.vue';
import { i18n } from "@/i18n/i18n-setup";

interface selectedUser {
    username: string,
    idUser: string,
}

@Component({
    components: {
        UserMatrixForm,
    }
})
export default class UserMatrixsDetail extends Vue {

    @Prop({ type: Object, required: false })
    selectedUserProp: selectedUser;

    showLoading: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };

    selectedUser: selectedUser = null;
    matrixDetails: Array<any> = null;
    selectedMatrix: Array<any> = new Array<any>();
    cbArray: Array<boolean> = new Array<boolean>();
    selectAllCheckBox: boolean = false;

    async mounted() {
        this.selectedUser = this.selectedUserProp;
        this.searchUsersMatrixAsync();
    }

    async searchUsersMatrixAsync() {
        this.showLoading = true;
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/GetUserMatrixForUser'),
                data: {
                    UserId: this.selectedUser.idUser
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItems.resultPage = results.data.listPage;
            this.resultsItems.total = results.data.total;

            this.showLoading = false;

        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }

    deleteMatrix(matrix: any) {
        let message = i18n.t('NET20.USER_MANAGEMENT_QUESTION_DELETE') as string;
        General.confirm(
            message,
            this,
            async () => {
                await this.deleteMatrixDo(matrix);
            }
        );
    }

    async deleteMatrixDo(matrix: any) {
        try {
            await axios({
                method: 'delete',
                url: General.GetApiUrl('/api/net20/DeleteUserMatrix'),
                data: matrix,
                withCredentials: true,
                responseType: 'json'
            });

            General.showAlertSuccess(i18n.t('NET20.USER_MANAGEMENT_AUTHORIZATION_DELETED_MSG') as string, this);
            this.searchUsersMatrixAsync();
        } catch (ex) {
            General.HandleError(ex, this);
        }
    }

    deleteSelectedMatrix() {
        let message = i18n.t('NET20.USER_MANAGEMENT_CONFIRM_DELETE_MULTIPLE') as string;
        General.confirm(
            message,
            this,
            async () => {
                await this.deleteSelectedMatrixDo();
            }
        );
    }

    async deleteSelectedMatrixDo() {
        try {
            await axios({
                method: 'delete',
                url: General.GetApiUrl('/api/net20/DeleteUsersMatrix'),
                data: this.selectedMatrix,
                withCredentials: true,
                responseType: 'json'
            });
            
            this.selectedMatrix = new Array<any>();
            this.cbArray = [];

            General.showAlertSuccess(i18n.t('NET20.USER_MANAGEMENT_MULTIPLE_AUTHORIZATION_DELETED_MSG') as string, this);
            this.searchUsersMatrixAsync();
        } catch (ex) {
            General.HandleError(ex, this);
        }
    }

    onSelectingCheckBox(matrix: any, checked) {
        if(checked) {
            this.selectedMatrix.push(matrix);
        } else {
            let index = this.selectedMatrix.findIndex(x => x.idUser === matrix.idUser
                                                            && x.userType === matrix.userType
                                                            && x.idCountry === matrix.idCountry
                                                            && x.idChannel === matrix.idChannel)
            if(index > -1) {
                this.selectedMatrix.splice(index, 1)

                if(this.selectAllCheckBox)
                    this.selectAllCheckBox = false;
            }
        }
    }

    onSelectingAllCheckBox(checked) {
        if(checked) {
            this.selectedMatrix = new Array<any>();
            this.selectedMatrix = this.selectedMatrix.concat(this.resultsItems.resultPage);
            this.cbArray = new Array<boolean>();
            this.selectedMatrix.forEach(element => {
                this.cbArray.push(true);
            });
        } else {
            this.selectedMatrix.splice(0,this.selectedMatrix.length);
            this.cbArray.splice(0,this.cbArray.length);
        }
    }

    openCreationModal(): void {
        this.$bvModal.show('matrix-form-user-modal');
    }

    closeModal(modalName: string) {
        this.$bvModal.hide(modalName);
    }
}
